// Generated by scripts/sync-admin-theme.cjs from Raj design-system tokens.
export const platformTheme = {
  "light": {
    "colorQrForeground": "#111827",
    "colorQrBackground": "#ffffff",
    "colorBrand": "#087a5b",
    "colorBrandHover": "#06684d",
    "colorBrandActive": "#05543f",
    "colorBrandSubtle": "#edf8f4",
    "colorBrandMuted": "#d2eee4",
    "colorOnBrand": "#ffffff",
    "colorSurfaceCanvas": "#f5f8f7",
    "colorSurface": "#ffffff",
    "colorSurfaceRaised": "#ffffff",
    "colorSurfaceMuted": "#f8faf9",
    "colorMediaWorkspace": "#111827",
    "colorMediaWorkspaceRaised": "#182235",
    "colorMediaWorkspaceBorder": "#263651",
    "colorMediaWorkspaceSelected": "#36457a",
    "colorOnMediaWorkspace": "#f8fafc",
    "colorOnMediaWorkspaceMuted": "#a9bad3",
    "colorText": "#17221f",
    "colorTextMuted": "#63736d",
    "colorTextSubtle": "#7b8984",
    "colorBorder": "#dce5e1",
    "colorBorderStrong": "#b7c8c1",
    "colorFocus": "#0b795c",
    "colorDanger": "#b42335",
    "colorDangerSubtle": "#fff0f1",
    "colorOnDanger": "#ffffff",
    "colorWarning": "#9a5b00",
    "colorWarningSubtle": "#fff7e6",
    "colorOnWarning": "#ffffff",
    "colorSuccess": "#157347",
    "colorSuccessSubtle": "#ebf8f1",
    "colorOnSuccess": "#ffffff",
    "colorInfo": "#245bb2",
    "colorInfoSubtle": "#eef4ff",
    "colorOnInfo": "#ffffff",
    "colorOverlay": "rgb(4 18 13 / 48%)",
    "colorChart1": "#087a5b",
    "colorChart2": "#2868b2",
    "colorChart3": "#b66512",
    "colorChart4": "#884ea0",
    "colorChart5": "#2d7d8b",
    "colorChart6": "#a83c5b"
  },
  "dark": {
    "colorQrForeground": "#111827",
    "colorQrBackground": "#f8fafc",
    "colorBrand": "#67d2ad",
    "colorBrandHover": "#82dfbf",
    "colorBrandActive": "#a2e9cf",
    "colorBrandSubtle": "#20372f",
    "colorBrandMuted": "#294b3f",
    "colorOnBrand": "#071b14",
    "colorSurfaceCanvas": "#0e1614",
    "colorSurface": "#17211e",
    "colorSurfaceRaised": "#1d2925",
    "colorSurfaceMuted": "#121c19",
    "colorMediaWorkspace": "#080d0c",
    "colorMediaWorkspaceRaised": "#111a17",
    "colorMediaWorkspaceBorder": "#31413b",
    "colorMediaWorkspaceSelected": "#294b3f",
    "colorOnMediaWorkspace": "#e8f0ed",
    "colorOnMediaWorkspaceMuted": "#a4b4ae",
    "colorText": "#e8f0ed",
    "colorTextMuted": "#a4b4ae",
    "colorTextSubtle": "#879991",
    "colorBorder": "#31413b",
    "colorBorderStrong": "#50635c",
    "colorFocus": "#82dfbf",
    "colorDanger": "#ff8790",
    "colorDangerSubtle": "#3f2025",
    "colorOnDanger": "#3a1218",
    "colorWarning": "#f1bd62",
    "colorWarningSubtle": "#3c2d17",
    "colorOnWarning": "#2a1c08",
    "colorSuccess": "#72d4a3",
    "colorSuccessSubtle": "#18372a",
    "colorOnSuccess": "#0a2418",
    "colorInfo": "#8ab7ff",
    "colorInfoSubtle": "#1b2e4a",
    "colorOnInfo": "#0b1a33",
    "colorOverlay": "rgb(0 0 0 / 65%)",
    "colorChart1": "#67d2ad",
    "colorChart2": "#79aefa",
    "colorChart3": "#e4a953",
    "colorChart4": "#c795d9",
    "colorChart5": "#70c1cc",
    "colorChart6": "#e1849d"
  }
} as const;
